import { Box, Grid, Text, Title } from '@bottlebooks/gatsby-design-system';

export function PageHeader({ children, ...rest }) {
  return (
    <Grid sx={{ paddingBottom: 4 }} {...rest}>
      {children}
    </Grid>
  );
}

export function PageTitle({ children, ...rest }) {
  return (
    <Box sx={{ textAlign: 'center' }} {...rest}>
      <Title>{children}</Title>
    </Box>
  );
}

export function PageSubtitle({ children, ...rest }) {
  return (
    <Box sx={{ textAlign: 'center' }} {...rest}>
      <Text>{children}</Text>
    </Box>
  );
}
